import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";
import VDistpicker from "v-distpicker";


import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import { isWeixin, parseQuery } from "@utils";
import {getLevel} from "@api/store";




Vue.use(animate);
Vue.component("v-distpicker",VDistpicker)
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function(rule) {
  return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;

const CACHE_KEY = "clear_0.0.1";

if (!cookie.has(CACHE_KEY)) {
  cookie.clearAll();
  cookie.set(CACHE_KEY, 1);
}

let cookieName = "VCONSOLE";
let query = parseQuery();
let urlSpread = query["spread"];
let vconsole = query[cookieName.toLowerCase()];
let md5Crmeb = "b14d1e9baeced9bb7525ab19ee35f2d2"; //CRMEB MD5 加密开启vconsole模式
let md5UnCrmeb = "3dca2162c4e101b7656793a1af20295c"; //UN_CREMB MD5 加密关闭vconsole模式

if (urlSpread !== undefined) {
  var spread = cookie.get("spread");
  urlSpread = parseInt(urlSpread);
  if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
    cookie.set("spread", urlSpread || 0);
  } else if (spread === 0 || typeof spread !== "number") {
    cookie.set("spread", urlSpread || 0);
  }
}

const _isWechat = isWeixin();

if (vconsole !== undefined) {
  if (vconsole === md5UnCrmeb && cookie.has(cookieName))
    cookie.remove(cookieName);
} else vconsole = cookie.get(cookieName);

if (vconsole !== undefined && vconsole === md5Crmeb) {
  cookie.set(cookieName, md5Crmeb, 3600);
  const module = () => import("vconsole");
  module().then(Module => {
    new Module.default();
  });
}

if (_isWechat) {
  const module = () => import("@libs/wechat");
  module().then(Module => {
    Module.default().then(() => Module.oAuth());
  });
}

const $vm = new Vue({
  router,
  store,
  render: h => h(App)
});

router.beforeEach((to, from, next) => {
    var that = this;
    console.log("---beforeEach-----")
    if (to.path == '/dian'){//店中店
        getLevel().then(res => {
            console.log(res);
        var status = res.data.status;
        var type = res.data.type;
        if(status==0){
            next({path:'/shenhe'});
            return
        }
        if (type == 0) {
            if (status == 1) {
                console.log("-----goods_list----")
                next({path:'/category'})
                //that.$router.push({path: 'goods_list', query: {gid: 101}})
            } else {
                console.log("-----shenhe----")
                next({path:'/shenhe'})
                // that.$router.push({path: "/shenhe"});
            }
        }else if (type == 1){
            next({path:'/category'})
        }else if (type == 2){
            alert("你已经成为地摊经济")
        }else if (type == 3){
            //next({path:'/goods_list', query: {gid: 101,dian:0}})
            next({path:'/category', query: {type: 3,level:2}})
        }else if (type == 4){
            alert("你已经成为裸片区")
        }else if (type == -1){
            next()
        }
    })
    }else if (to.path == '/flagship'){//旗舰店
        getLevel().then(res => {
            console.log(res);
            var status = res.data.status;
            var type = res.data.type;
            if(status==0){
                next({path:'/shenhe'});
                return
            }
            if (type == 1) {
                if (status == 1) {
                    console.log("-----goods_list----")
                    next({path:'/category'})
                    //that.$router.push({path: 'goods_list', query: {gid: 101}})
                } else {
                    console.log("-----shenhe----")
                    next({path:'/shenhe'})
                   // that.$router.push({path: "/shenhe"});
                }
            }else if (type == 0){
                alert("你已经是店中店")
            }else if (type == 2){
                alert("你已经成为地摊经济")
            }else if (type == 3){
                next({path:'/category', query: {type: 3,level:3}})
            }else if (type == 4){
                alert("你已经成为裸片区")
            }else if (type == -1){
              next()
            }
        })
    }else if (to.path == '/ditang'){//地摊经济
        getLevel().then(res => {
            console.log(res);
        var status = res.data.status;
        var type = res.data.type;
        if(status==0){
            next({path:'/shenhe'});
            return
        }
        if (type == 2) {
            if (status == 1) {
                console.log("-----goods_list----")
                next({path:'/category'})
                //that.$router.push({path: 'goods_list', query: {gid: 101}})
            } else {
                console.log("-----shenhe----")
                next({path:'/shenhe'})
                // that.$router.push({path: "/shenhe"});
            }
        }else if (type == 0){
            next({path:'/category'})
        }else if (type == 1){
            next({path:'/category'})
        }else if (type == 3){
            next({path:'/category', query: {type: 3,level:5}})//type 为业务员身份 level 为对应的区域编号
        }else if (type == 4){
            alert("你已经成为裸片区")
        }else if (type == -1){
            next()
        }
    })
    }else if (to.path == '/yewuy'){//业务员
        getLevel().then(res => {
            console.log(res);
        var status = res.data.status;
        var type = res.data.type;
        if(status==0){
            next({path:'/shenhe'});
            return
        }
        if (type == 3) {
            if (status == 1) {
                console.log("-----goods_list----")
                next({path:'/user/user_promotion'})
                //that.$router.push({path: 'goods_list', query: {gid: 101}})
            } else {
                console.log("-----shenhe----")
                next({path:'/shenhe'})
                // that.$router.push({path: "/shenhe"});
            }
        }else if (type == 0){
            alert("你已经是店中店")
        }else if (type == 1){
            alert("你已经是旗舰店")
        }else if (type == 2){
            alert("你已经是地摊经济")
        }else if (type == 4){
            alert("你已经成为裸片区")
        }else if (type == -1){
            next()
        }
     })
    }else if (to.path == '/luopian'){//裸片区
        getLevel().then(res => {
            console.log(res);
        var status = res.data.status;
        var type = res.data.type;
        if(status==0){
            next({path:'/shenhe'});
            return
        }
        if (type == 4) {
            if (status == 1) {
                console.log("-----goods_list----")
                next({path:'/goods_list', query: {id: 38,title:"裸片区"}})
                //that.$router.push({path: 'goods_list', query: {gid: 101}})
            } else {
                console.log("-----shenhe----")
                next({path:'/shenhe'})
                // that.$router.push({path: "/shenhe"});
            }
        }else if (type == 0){
            next({path:'/goods_list', query: {id: 38,title:"裸片区"}})
        }else if (type == 1){
            next({path:'/goods_list', query: {id: 38,title:"裸片区"}})
        }else if (type == 2){
            next({path:'/goods_list', query: {id: 38,title:"裸片区"}})
        }else if (type == 3){
            next({path:'/goods_list', query: {id: 38,title:"裸片区",type:3,level:6}})
        }else if (type == -1){
            next()
        }
    })
    }else if (to.path == '/address'){
        next({path:'/order/list'})
    }else if (to.path == '/news_list'){
        next({path:'/news_detail/2'})
    }else{
      next()
    }
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
